var _rect, _path, _path2, _path3, _path4, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAssignmentContent = function SvgAssignmentContent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.667,
    width: 41,
    height: 40,
    rx: 8,
    fill: "#FFDF6B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M22.488 26.643H11.382a.466.466 0 0 1-.467-.456V10.45c0-.249.212-.456.467-.456h11.106c.26 0 .467.207.467.456v15.737a.462.462 0 0 1-.467.456Z",
    fill: "url(#assignment-content_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M25.219 29.176h-11.1a.473.473 0 0 1-.33-.134.45.45 0 0 1-.137-.322V12.99c0-.255.213-.457.468-.457h11.105c.261 0 .467.207.467.456v15.737c0 .248-.212.45-.473.45Z",
    fill: "url(#assignment-content_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m30.013 16.378 1.402-1.262-1.894-2.007-1.438 1.291 1.93 1.978Z",
    fill: "url(#assignment-content_svg__c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.184 15.2 20.735 21l-.771 2.528 2.67-.52 6.481-5.826-1.93-1.984Z",
    fill: "url(#assignment-content_svg__d)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "assignment-content_svg__a",
    x1: 9.001,
    y1: 15.501,
    x2: 24.776,
    y2: 21.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "assignment-content_svg__b",
    x1: 19.669,
    y1: 29.177,
    x2: 19.669,
    y2: 12.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "assignment-content_svg__c",
    x1: 28.08,
    y1: 14.743,
    x2: 31.417,
    y2: 14.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "assignment-content_svg__d",
    x1: 26.471,
    y1: 14.947,
    x2: 23.035,
    y2: 24.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.7
  })))));
};

export default SvgAssignmentContent;